module.exports = __webpack_public_path__ + "static/media/OK_Button@3x.3872ff50.png";